export const GET_ACCOUNT = 'GET_ACCOUNT' as const;
export const SET_ACCOUNT = 'SET_ACCOUNT' as const;

export const msalScopes = [process.env.REACT_APP_AZURE_READACCESS_SCOPE_ID];
